"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fail = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactI18next = require("react-i18next");
var _ui = require("../../../../../ui");
var _utils = require("../../../../../../utils");
var _hooks = require("../../../../../../hooks");
var _constants = require("../../../../../../constants");
var _AmountToPay = require("./AmountToPay");
var _Footer = require("./Footer");
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var ModalBody = (0, _styledComponents.default)(_ui.ModalBody)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 20px 20px 30px;\n  ", "\n"])), _utils.mediaQuery.lessThan('sm')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: 0 10px 40px;\n  "]))));
var BankAnswer = (0, _styledComponents.default)(_ui.H3)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin: 20px 0;\n  text-align: center;\n"])));
var Fail = function Fail() {
  var _useTranslation = (0, _reactI18next.useTranslation)('libTransfers'),
    t = _useTranslation.t;
  var _useReplenishContext = (0, _hooks.useReplenishContext)(),
    fiat = _useReplenishContext.fiat;
  return /*#__PURE__*/_react.default.createElement(_ui.Modal, {
    isOpen: fiat.status === _constants.PaySoftStatus.FAIL,
    toggle: fiat.toggleModal
  }, /*#__PURE__*/_react.default.createElement(_ui.ModalHeader, {
    className: "pb-2",
    onClick: fiat.toggleModal
  }), /*#__PURE__*/_react.default.createElement(ModalBody, null, /*#__PURE__*/_react.default.createElement(_ui.H2, {
    className: "text-center"
  }, t('failed'), " \uD83D\uDE14"), /*#__PURE__*/_react.default.createElement(BankAnswer, null, t('declined'), ": ", fiat.errorMessage), /*#__PURE__*/_react.default.createElement(_AmountToPay.AmountToPay, {
    amount: fiat.totalValue,
    ticker: fiat.ticker,
    text: t('amount')
  }), /*#__PURE__*/_react.default.createElement(_Footer.Footer, null)));
};
exports.Fail = Fail;